import type { ContentType } from "@/mocks/content";

const styles: Record<string, string> = {
  news: "bg-primary-100 text-primary-700",
  video: "bg-secondary-100 text-secondary-900",
  encyclopedia: "bg-accent-100 text-accent-900",
};

const labels: Record<string, string> = {
  news: "新闻",
  video: "视频",
  encyclopedia: "百科",
};

export default function TypeBadge({ type }: { type: ContentType }) {
  return (
    <span className={`rounded px-1.5 py-0.5 text-xs whitespace-nowrap ${styles[type]}`}>
      {labels[type]}
    </span>
  );
}